import { HttpClient } from '@angular/common/http';
import { TranslateFakeLoader, TranslateLoader } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { TranslateLoaderFactory } from './app.translations';

export const APP_TRANSLATE_CONFIG = environment.translationsEnabled
  ? {
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient],
      },
      useDefaultLang: false,
    }
  : {
      loader: {
        provide: TranslateLoader,
        useClass: TranslateFakeLoader,
      },
      useDefaultLang: false,
    };

export const OUTSIDE_DOMAINS: string[] = ['brreg.no', environment.services.translation];
